/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ESickNoteNpCaseDurationConfirmationSchema } from '../models/ESickNoteNpCaseDurationConfirmationSchema';
import type { ESickNoteNpCaseReportSchema } from '../models/ESickNoteNpCaseReportSchema';
import type { ESickNoteNpLongTermCareCaseClosureSchema } from '../models/ESickNoteNpLongTermCareCaseClosureSchema';
import type { ESickNoteNpLongTermCareCaseCreateSchema } from '../models/ESickNoteNpLongTermCareCaseCreateSchema';
import type { ESickNoteNpLongTermCareCaseDetailSchema } from '../models/ESickNoteNpLongTermCareCaseDetailSchema';
import type { ESickNoteSubmissionDetailSchema } from '../models/ESickNoteSubmissionDetailSchema';
import type { PagedESickNoteNpLongTermCareCaseDetailSchema } from '../models/PagedESickNoteNpLongTermCareCaseDetailSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EsickNotesNpLongTermCareApi {
    /**
     * Create Esick Note Np Long Term Care Case
     * Issue a long-term care decision and submit it to ČSSZ (ČSSZ Rpdp1). Required Permission: create_esick_note
     * @returns ESickNoteNpLongTermCareCaseDetailSchema Created
     * @throws ApiError
     */
    public static esickNoteNpLongTermCareCreateEsickNoteNpLongTermCareCasePost({
        requestBody,
    }: {
        requestBody: ESickNoteNpLongTermCareCaseCreateSchema,
    }): CancelablePromise<ESickNoteNpLongTermCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/np/long-term-care/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Esick Note Np Long Term Care Case List
     * List long-term care cases of the logged-in user's company. Required Permission: create_esick_note
     * @returns PagedESickNoteNpLongTermCareCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpLongTermCareGetEsickNoteNpLongTermCareCaseListGet({
        patientId,
        open,
        needsDurationConfirmation,
        limit = 100,
        offset,
    }: {
        patientId?: (string | null),
        open?: (boolean | null),
        /**
         * Open cases whose need for care has not been confirmed to ČSSZ for 25 days or more.
         */
        needsDurationConfirmation?: (boolean | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedESickNoteNpLongTermCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/np/long-term-care/',
            query: {
                'patient_id': patientId,
                'open': open,
                'needs_duration_confirmation': needsDurationConfirmation,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create Esick Note Np Long Term Care Case Report
     * Submit an attending doctor's report on long-term care: handing the case over, a hospitalization or a change of diagnosis (ČSSZ HolNp). The report is stored with the submission history and reflected in the case's current state, which is returned. Required Permission: create_esick_note
     * @returns ESickNoteNpLongTermCareCaseDetailSchema Created
     * @throws ApiError
     */
    public static esickNoteNpLongTermCareCreateEsickNoteNpLongTermCareCaseReportPost({
        npCaseId,
        requestBody,
    }: {
        npCaseId: string,
        requestBody: ESickNoteNpCaseReportSchema,
    }): CancelablePromise<ESickNoteNpLongTermCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/np/long-term-care/{np_case_id}/reports/',
            path: {
                'np_case_id': npCaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Esick Note Np Long Term Care Case
     * Long-term care case detail. Required Permission: create_esick_note
     * @returns ESickNoteNpLongTermCareCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpLongTermCareGetEsickNoteNpLongTermCareCaseGet({
        npCaseId,
    }: {
        npCaseId: string,
    }): CancelablePromise<ESickNoteNpLongTermCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/np/long-term-care/{np_case_id}/',
            path: {
                'np_case_id': npCaseId,
            },
        });
    }
    /**
     * Get Esick Note Np Long Term Care Case Submission List
     * List every podání ČSSZ accepted for this long-term care case, newest first, with what was sent. Required Permission: create_esick_note
     * @returns ESickNoteSubmissionDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpLongTermCareGetEsickNoteNpLongTermCareCaseSubmissionListGet({
        npCaseId,
    }: {
        npCaseId: string,
    }): CancelablePromise<Array<ESickNoteSubmissionDetailSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/np/long-term-care/{np_case_id}/submissions/',
            path: {
                'np_case_id': npCaseId,
            },
        });
    }
    /**
     * Set Esick Note Np Long Term Care Case Closure
     * End the need for long-term care and report it to ČSSZ with the final diagnosis (ČSSZ Rpdp2). Required Permission: create_esick_note
     * @returns ESickNoteNpLongTermCareCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpLongTermCareSetEsickNoteNpLongTermCareCaseClosurePut({
        npCaseId,
        requestBody,
    }: {
        npCaseId: string,
        requestBody: ESickNoteNpLongTermCareCaseClosureSchema,
    }): CancelablePromise<ESickNoteNpLongTermCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/esick-notes/np/long-term-care/{np_case_id}/closure/',
            path: {
                'np_case_id': npCaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Set Esick Note Np Long Term Care Case Duration Confirmation
     * Confirm to ČSSZ that the need for long-term care continues; required at least monthly (ČSSZ PtNp). Required Permission: create_esick_note
     * @returns ESickNoteNpLongTermCareCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpLongTermCareSetEsickNoteNpLongTermCareCaseDurationConfirmationPut({
        npCaseId,
        requestBody,
    }: {
        npCaseId: string,
        requestBody: ESickNoteNpCaseDurationConfirmationSchema,
    }): CancelablePromise<ESickNoteNpLongTermCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/esick-notes/np/long-term-care/{np_case_id}/duration-confirmation/',
            path: {
                'np_case_id': npCaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Sync Esick Note Np Long Term Care Case From Cssz
     * Read the case back from ČSSZ now and update its state, end, start, diagnosis and takeover (ČSSZ IkreNpVratDetailPripadu); the same runs daily for every open case. Required Permission: create_esick_note
     * @returns ESickNoteNpLongTermCareCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpLongTermCareSyncEsickNoteNpLongTermCareCaseFromCsszPost({
        npCaseId,
    }: {
        npCaseId: string,
    }): CancelablePromise<ESickNoteNpLongTermCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/np/long-term-care/{np_case_id}/cssz-sync/',
            path: {
                'np_case_id': npCaseId,
            },
        });
    }
}
